import React from 'react';
import { AppStore, Store } from './styles';
import { ReactComponent as Applestore } from '../../assets/landingPage/Applestore.svg';
import { ReactComponent as Playstore } from '../../assets/landingPage/Playstore.svg';

import { ReactComponent as ApplestoreBanner } from '../../assets/landingPage/ApplestoreBanner.svg';
import { ReactComponent as PlaystoreBanner } from '../../assets/landingPage/PlaystoreBanner.svg';

const AppStoreComponent = ({ landingPage, primaryColor }) => {
  return (
    <AppStore primaryColor={primaryColor}>
      {landingPage && <small className='title'>baixe o nosso app:</small>}
      <div className='stores'>
        <a
          href='https://play.google.com/store/apps/details?id=com.podemorar'
          target='_blank'
          rel='noreferrer'
        >
          <Store primaryColor={primaryColor}>
            {landingPage ? <Playstore /> : <PlaystoreBanner />}
            <span>
              <small>Download em:</small>
              <small>Play Store</small>
            </span>
          </Store>
        </a>
        <a
          href='https://apps.apple.com/br/app/pode-morar/id1569813219'
          target='_blank'
          rel='noreferrer'
        >
          <Store primaryColor={primaryColor}>
            {landingPage ? <Applestore /> : <ApplestoreBanner />}
            <span>
              <small>Download em:</small>
              <small>Apple Store</small>
            </span>
          </Store>
        </a>
      </div>
    </AppStore>
  );
};

export default AppStoreComponent;
